// BASE_URL is replaced at build time by esbuild
const rawBaseUrl = BASE_URL as string;

function normalizeBaseUrl(v: string): string {
    const trimmed = (v ?? "").trim();
    if (!trimmed) return ""; // relative to current origin
    // If someone accidentally built with http://... but served over https, fix mixed-content.
    if (typeof window !== "undefined" && window.location?.protocol === "https:" && trimmed.startsWith("http://")) {
        return `https://${trimmed.slice("http://".length)}`;
    }
    // Protocol-relative URLs should inherit current page protocol.
    if (typeof window !== "undefined" && trimmed.startsWith("//")) {
        return `${window.location.protocol}${trimmed}`;
    }
    return trimmed;
}

export const config = {
    baseUrl: normalizeBaseUrl(rawBaseUrl),
};
